<template><div><h1 id="product-manager" tabindex="-1"><a class="header-anchor" href="#product-manager"><span>Product Manager</span></a></h1>
<p>Product Manager — Definition der Product Manager im System</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>&gt;Definiert die Product Manager im System, welche im Artikelstamm eingegeben werden können. Der Productmanager ist ein wichtiges Kriterium bei Auswertungen / Statistiken im Bereich Lagerverwaltung.</p>
<p>Pfad: <code v-pre>Logistik → Tabellen → Product Managers</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Code</dt>
<dd>Kürzel für Product Manager, meist identisch mit Benutzerkürzel im System</dd>
<dt>Name</dt>
<dd>Name des Product Managers</dd>
<dt>Telefon</dt>
<dd>Telefonnummer des Product Managers</dd>
<dt>Konto</dt>
<dd>Finanzbuchhaltungskonto Product Manager. Angabe nur notwendig, wenn in der Tabelle &quot;Kontierungsquellen&quot; der Product Manager angegeben wurde. Sonst leer lassen</dd>
<dt>Kostenstelle</dt>
<dd>siehe [Konto]</dd>
<dt>Kostenträger</dt>
<dd>siehe [Konto]</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<p>Standardfunktionalität</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/manual/trade/artikel_und_lagerverwaltung.html" title="3. Artikel- und Lagerverwaltung">Lagerverwaltung</RouteLink></p>
</div></template>


